import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2, FileArchive, X } from "lucide-react";
import { saveBlob } from "@/components/invoice/invoiceUtils";
import { useI18n } from "@/context/I18nContext";
import { fl } from "@/lib/finI18n";

export function InvoiceBulkBar({ ids, onClear, onDone }) {
  const { lang } = useI18n();
  if (!ids.length) return null;
  const del = async () => {
    if (!window.confirm(`${fl("bulkDelQ", lang)} (${ids.length})`)) return;
    try {
      const { data } = await api.post("/invoices/bulk-delete", { ids });
      toast.success(`${data.deleted} ${fl("bulkDeleted", lang)}`);
      data.skipped.forEach((s) => toast.error(`${s.invoice_no}: ${s.reason}`));
      onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const zip = async () => {
    try {
      const res = await api.post("/invoices/bulk-pdf", { ids, lang }, { responseType: "blob" });
      saveBlob(res.data, `invoice_${new Date().toISOString().slice(0, 10)}.zip`);
    } catch (e) { toast.error(fl("zipFail", lang)); }
  };
  return (
    <div className="flex items-center gap-2 flex-wrap rounded-md border border-primary/30 bg-primary/5 px-3 py-2 mb-3" data-testid="invoice-bulk-bar">
      <span className="text-sm font-medium" data-testid="invoice-bulk-count">{ids.length} {fl("bulkSel", lang)}</span>
      <Button size="sm" variant="outline" onClick={zip} data-testid="invoice-bulk-zip"><FileArchive className="h-4 w-4 mr-1" />Download ZIP</Button>
      <Button size="sm" variant="outline" className="text-rose-600" onClick={del} data-testid="invoice-bulk-delete"><Trash2 className="h-4 w-4 mr-1" />{fl("del", lang)}</Button>
      <Button size="sm" variant="ghost" onClick={onClear} data-testid="invoice-bulk-clear"><X className="h-4 w-4 mr-1" />{fl("cancel", lang)}</Button>
    </div>
  );
}
